// extracted by mini-css-extract-plugin
export default {"root":"LoadingView_root__peyXx","loader":"LoadingView_loader__pr6od"};